<div class="login">
    <div class="login--center">
        <div class="login--center-panel">
            <div class="brand_name">
                <!-- Pro Suite -->
            </div>

            <div class="panel">
                <div class="access">
                    <div class="access--login">
                        @if(!selectTenants) {
                            <!-- LOGIN FORM -->
                            <div class="login_form">
                                @if (isAltLogin) {
                                    <h3 class="mb-3">{{auth0TenantName}} Authentication</h3>
                                }
                                
                                <aurora-button
                                        block
                                        variant="primary"
                                        [class.py-4]="isAltLogin"
                                        id="loginButton"
                                        (click)="onLoginClick.emit()">
                                    {{ isAltLogin ? `Login with ${ auth0TenantName } Auth0` : 'Login' }}
                                </aurora-button>
                                @if (errorMessage) {
                                    <div id="loginError" class="alert alert-danger mt-2">
                                        Login failed: {{ errorMessage }}
                                    </div>
                                }
                                @if (isAltLogin) {
                                    <div class="mt-3">
                                        <aurora-link-button class="nav-item"
                                                (click)="onGoToPrimaryLogin.emit()">
                                            &#8592; Back to Primary Login
                                        </aurora-link-button>
                                    </div>
                                }
                            </div>
                        } @else {
                            <!-- SELECT TENANT -->
                            <select-tenant
                                [selectedTenant]="selectedTenant"
                                [tenants]="tenants"
                                (onTenantSelect)="tenantSelect($event)"
                                (onChangeUser)="onChangeUser.emit()">
                            </select-tenant>
                        }
                    </div>
                    @if (loading) {
                        <aurora-loading-indicator overlay></aurora-loading-indicator>
                    }
                </div>
            </div>

            <footer>
                <a href="https://insurity.com" target="_blank">
                    <img src="assets/logo-insurity-white.svg"
                         alt="Insurity, LLC logo"
                         class="insurity_logo" />
                </a>
            </footer>

        </div>
    </div>
</div>
